/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCheckBlocklistRequest
 */
export interface ControlCheckBlocklistRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlCheckBlocklistRequest
     */
    domains: Array<string>;
}

/**
 * Check if a given object implements the ControlCheckBlocklistRequest interface.
 */
export function instanceOfControlCheckBlocklistRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domains" in value;

    return isInstance;
}

export function ControlCheckBlocklistRequestFromJSON(json: any): ControlCheckBlocklistRequest {
    return ControlCheckBlocklistRequestFromJSONTyped(json, false);
}

export function ControlCheckBlocklistRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCheckBlocklistRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'domains': json['domains'],
    };
}

export function ControlCheckBlocklistRequestToJSON(value?: ControlCheckBlocklistRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'domains': value.domains,
    };
}

